import { BarChartOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import styled from "styled-components";

export const ReportsWrapper = styled.div`
  padding: 20px;
`;

export const Flex = styled.div<{ justify?: string; align?: string; gap?: number }>`
  display: flex;
  justify-content: ${(props) => props.justify || "flex-start"};
  align-items: ${(props) => props.align || "flex-start"};
  gap: ${(props) => (props.gap ? `${props.gap}px` : "0")};
`;

export const FlexWrapper = styled(Flex)`
  gap: 6px;
  align-items: center;
  vertical-align: middle;

  @media (max-width: 620px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const InfoWrapper = styled(Flex)`
  gap: 8px;
  align-items: center;

  @media (max-width: 530px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const EditIcon = styled(EditOutlined)`
  font-size: 20px;
  cursor: pointer;
`;

export const InfoText = styled.div`
  span {
    font-size: 14px;
    color: #000;
  }

  span:first-child {
    color: #000;
  }
`;

export const Label = styled.span`
  text-wrap: nowrap;
  color: #000;
  font-size: 14px;
`;

export const ActionWrapper = styled(Flex)`
  gap: 12px;
  margin: 0;

  @media (max-width: 650px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const SelectWrapper = styled(Flex)`
  width: 100%;
  gap: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledBarChartIcon = styled(BarChartOutlined)`
  font-size: 20px;
  color: #545965;
`;

export const CloseOutlinedIcon = styled(CloseOutlined)`
  margin-left: 8px;
`;


export const StyledHeading = styled.h3`
  font-weight: 500;
  color: #545965;
  margin: 0;
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 1100px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const InfoTextWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const SelectContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;

export const LostInfoText = styled.div`

  span {
    font-size: 14px;
    color: #000;
  }

  span:first-child {
    color: #000;
  }
`;

export const ReportedInfoText = styled.div`

  span {
    font-size: 14px;
    color: #000;
  }

  span:first-child {
    color: #000;
  }

  @media (max-width: 530px) {
    margin-top: 0px;
  }
`;

export const PenIconWrapper = styled.div`
  cursor: pointer;
  position: relative;
`;

export const DatePickerWrapper = styled.div`
  position: relative;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #F0F0F0;
  vertical-align: middle;

  @media (max-width: 792px) {
    gap: 10px;
    flex-direction: column;
    align-items: center;
  }
`;

export const AddLostItemButton = styled(Button)`
  display: flex;
  padding: 10px 20px;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  font-size: 14px;
  height: 40px;
`;